import DWA from 'actions/dod/dodWelcomeActions';

export function dodWelcomeUpdateStatus(s) {
    return { type: DWA.UPDATE_DOD_WELCOME_STATUS, payload: s };
}

export function dodWelcomeUpdateTitle(t) {
    return { type: DWA.UPDATE_DOD_WELCOME_TITLE, payload: t };
}
